import React from 'react'

interface LoadingSkeletonProps {
    count?: number
    height?: string
    width?: string
    margin?: string
    className?: string
    containerClassName?: string
    rounded?: string
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
    count = 1,
    height = 'h-80',
    width = 'w-[100%]',
    margin = 'mt-2',
    className = '',
    containerClassName = '',
    rounded = 'rounded-2xl',
}) => {
    return (
        <div className={`flex flex-col gap-1 ${containerClassName}`}>
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className={`
                        relative animate-pulse 
                        bg-eoe-input dark:bg-eoe-dark-input
                        ${height} ${width} ${margin} ${className} ${rounded}
                    `}
                />
            ))}
        </div>
    )
}

export default LoadingSkeleton